<!-- footer -->
<div class="footer" id="footer">
    <h1>
        <img src="./assets/img/Logo.svg" alt="">
    </h1>
    <div class="footCont">
        <div class="footInfo">
                <div class="btmMenu">
                    <ng-container *ngFor="let item of footerMenu">
                        <ng-container *ngIf="item.helpUrl">
                            <a [href]="item.helpUrl">{{ item.prgName }}</a>
                        </ng-container>
                        <ng-container *ngIf="!item.helpUrl && item.linkInfo">
                            <ng-container *ngIf="item.linkInfo === '/servicePage/privacy-policy'">
                                <a href="/policy.html">{{item.prgName}}</a>
                            </ng-container>

                            <ng-container *ngIf="item.linkInfo !== '/servicePage/privacy-policy'">
                              <a [routerLink]="item.linkInfo">{{item.prgName}}</a>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </div>
            <ng-container *ngIf="company$ | async as company">
                <div class="btmInfo">
                    <p>{{ company.comName }}</p>
                    <p>
                        <span>주소 : {{ company.addr }}</span>
                        <span>대표 : {{ company.comOwner }}</span>
                        <span>사업자등록번호 : {{ company.comTaxNo }}</span>
                    </p>
                    <p>
                        <span>통신판매업신고번호 :  {{ company.comTSNo }}</span>
                        <span>대표번호 : {{ company.tel }}</span>
                        <span>팩스번호 : {{ company.fax }}</span>
                    </p>
                </div>
            </ng-container>
            <p class="copy">© 2024, ALLRENU, LLC. All worldwide rights reserved.</p>
        </div>
        <div class="footCusto">
            <dl>
                <dt>Customer Center</dt>
                <dd>
                    <h2>031-429-1127</h2>
                    <p>상담시간 : 09:00 - 17:00 , 토,일, 공휴일 휴무</p>
                    <p>점심시간 : 12:00 – 13:00</p>
                </dd>
            </dl>
        </div>
    </div>
</div>
<!-- //footer -->
